import React, { useState, useEffect } from 'react'
import "./index.scss"
import {
    Row,
    Col,
    Input,
    Space,
    Dropdown,
    Button,
    Divider,
    message,
    Avatar
} from 'antd'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setBasic } from '../../../store/modules/basic';
import { setToken } from '../../../store/modules/token';

const logo = require("./image/logo.png")
const gx = require("./image/gx.png")

export default function HeaderView() {

    const dispatch = useDispatch()
        , navigate = useNavigate()
        , { serverUrl } = useSelector(state => state.siteInfo)
        , { id, name, imageUrl, companyName } = useSelector(state => state.basic)

    const onLogin = () => {
        navigate('/login')
    }

    const onRegister = () => {
        navigate('/register')
    }

    const handleMenuClick = (url) => {
        window.open(url, '_blank');
    }

    const logout = () => {
        dispatch(setBasic({}))
        dispatch(setToken({ token: null }))
        message.success('退出成功！')
    }

    const menuItems = [
        {
            key: '1',
            label: (
                <span onClick={() => window.open('/usercenter')}>
                    个人中心
                </span>
            ),
        },
        {
            key: '2',
            label: (
                <Divider style={{ margin: '2px 0' }} />
            ),
        },
        {
            key: '3',
            label: (
                <span onClick={() => logout()}>
                    退出登录
                </span>
            ),
        },
    ]


    return (
        <div className='header'>
            <div className='content'>
                <Row style={{ height: '100%' }}>
                    <Col span={14} className="left">
                        <img className='logo'
                            src={gx} alt="" />
                        <span className='title'>社会化服务平台</span>
                    </Col>
                    <Col span={10} className="right">

                        {
                            id ? (
                                <div
                                    className='user-info'
                                >
                                    <Dropdown
                                        menu={{
                                            items: menuItems,
                                        }}
                                        placement="bottomLeft"
                                    >
                                        <div className='flex center'>
                                            <Avatar src={serverUrl + imageUrl} alt="" />
                                            <div className='user-name'>{name}</div>
                                        </div>
                                    </Dropdown>
                                </div>
                            ) : (<Space size='small' split={<Divider type="vertical" />}>
                                <Button type='link' onClick={() => window.open('http://ynnj.yn-ag.cn/', '_blank')}>进入农机管理</Button>
                                <Button type='link' style={{ color: '#f08a47' }} onClick={onLogin}>您好，请登录</Button>
                                <Button type='link' style={{ color: '#f08a47' }} onClick={onRegister}>注册</Button>
                            </Space>)
                        }

                        {/* <Input.Search
                            className='search'
                            placeholder="请输入关键词"
                            allowClear
                            enterButton="搜索"
                            size="large"
                            addonBefore={<Select
                                style={{ width: '80px' }}
                                size='large'
                                defaultValue="服务"
                                options={[
                                    {
                                        value: '服务',
                                        label: '服务',
                                    },
                                    {
                                        value: '需求',
                                        label: '需求',
                                    },
                                    {
                                        value: '组织',
                                        label: '组织',
                                    },
                                ]}
                            />}
                        /> */}
                    </Col>
                </Row>
            </div>
        </div>
    )
}
